import { makeObservable, reaction } from "mobx";
import { AuthStore, BaseStore } from ".";


export class RootStore {
  routingStore = this.authStore.routingStore;

  private stores: BaseStore[] = [];

  constructor(public authStore: AuthStore) {
    makeObservable(this, { });

    this.stores = Object.keys(this)
      .filter((k) => k.endsWith("Store") && k !== "rootStore")
      .map((k) => (this as unknown as { [key: string]: BaseStore })[k]);

    reaction(() => this.authStore.isLoggedIn, () => {
        if (this.authStore.isLoggedIn) this.init();
        else this.clear();
    });
  }

  init() {
    this.stores.forEach((s) => s.init());
  }
  clear() {
    this.stores.forEach((s) => s.clear());
  }
}
